import styled from 'styled-components';

export const DragContainer = styled.div`
  color: ${({ theme }) => theme.colors.textPrimary};

  & span {
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;

export const DragGroupContainer = styled.div`
  color: ${({ theme }) => theme.colors.textPrimary};

  & span {
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;
